<template>
	<modal>
		<template slot="header">
			<md-button class="md-simple md-just-icon md-round modal-default-button" @click="closeFilterModal">
				<md-icon>clear</md-icon>
			</md-button>
		</template>
		<template slot="body">
			<div>
				<div class="filter-field-container">
					<md-field>
						<label>Industry</label>
						<md-select v-model="selectedIndustry" name="company-industry" id="industry" @input="handelIndustryChange" class="select-modal">
							<md-option v-for="(value, index) in companyIndustry" :key="index" :value="value">{{ value }}</md-option>
						</md-select>
					</md-field>
					<md-field>
						<label>Sector</label>
						<md-select v-model="selectedSector" name="company-sector" id="sector" @input="handelSectorChange">
							<md-option v-for="(value, index) in companySector" :key="index" :value="value">{{ value }}</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="filter-button-row">
					<md-button class="md-success" @click="handleClearFilters">Clear Filters</md-button>
					<md-button class="md-danger" @click="handleClose">Close</md-button>
				</div>
			</div>
		</template>
	</modal>
</template>

<script>
import { Modal } from '@/components';
export default {
	props: {
		companyData: { type: Array },
		selectedSectorValue: { type: String },
		selectedIndustryValue: { type: String },
	},
	components: {
		Modal,
	},
	data() {
		return {
			companySector: [],
			companyIndustry: [],
			selectedSector: this.selectedSectorValue,
			selectedIndustry: this.selectedIndustryValue,
		};
	},
	methods: {
		closeFilterModal() {
			this.$emit('closeFilterModal', false);
		},
		getUniquesProperties(property, dataList) {
			const uniqueValues = new Set(dataList.map(element => element[property]));
			return Array.from(uniqueValues).sort();
		},
		handelSectorChange() {
			this.$emit('sectorSelect', this.selectedSector);
		},
		handelIndustryChange() {
			this.$emit('industrySelect', this.selectedIndustry);
		},
		handleClearFilters() {
			this.selectedSector = null;
			this.selectedIndustry = null;
			this.$emit('industrySelect', this.selectedIndustry);
			this.$emit('sectorSelect', this.selectedSector);
		},
		handleClose() {
			this.$emit('closeFilterModal', false);
		},
	},
	created() {
		this.companyIndustry = this.getUniquesProperties('industry', this.companyData);
		this.companySector = this.getUniquesProperties('sector', this.companyData);
	},
};
</script>
<style scoped>
.filter-button-row {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}
</style>
